import { Query, Account } from "../services/api/savings-and-pension-queries.types";

export const getPortfolioInsightAccounts = (query: Query): Account[] => query?.portfolioInsight?.accounts ?? [];
